// @flow
import notExisty from './notExisty';

export default function isEmpty(val: mixed): boolean {
   return notExisty(val) || val instanceof Array && !val.length || typeof val === 'string' && !val.length;
}
